import { useDispatch } from "react-redux";
import { getToken, getTokenMember } from "../../utils/app.utils";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { Box, Checkbox, IconButton, Typography, useTheme } from "@mui/material";
import { useTransition } from "react";
import { IconComponents } from "../../assets/icons/icons";
import { isBoolean } from "lodash";
import { useNavigate } from "react-router-dom";
import { routeName } from "../../routes/routeName";
import { colors } from "../../constants/colors";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SpeedDialCustom from "../speed-dial/SpeedDialCustom";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import moment from "moment";
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

type optionContentProps = {
    count?: {
        like: number;
        like_checked: boolean;
        onLikeClick?: (status: boolean) => void;
        view: number;
        onViewClick?: () => void;
        shared: number;
        onSharedClick?: {
            xClick?: React.MouseEventHandler<HTMLDivElement>;
            lineClick?: React.MouseEventHandler<HTMLDivElement>;
            facebookClick?: React.MouseEventHandler<HTMLDivElement>;
        }
    }
    allow_light?: boolean;
    center?: boolean;
    around?: boolean;
    between?: boolean;
    evenly?: boolean;
    allow_col?: boolean;
    date?: Date | string;
    mode_light?: boolean;
    date_between?: boolean;
    date_row?: boolean;
}
export const OptionContent = (props: optionContentProps) => {
    const isAuthentication: boolean = !!getTokenMember();
    const navigate = useNavigate();
    // const isAcceptPrivacy: boolean = isAcceptCookie();
    const theme = useTheme();
    const mode = theme.palette.mode;
    const [isPending, startTransition] = useTransition();
    // const { mode } = useColorScheme();
    // const navigate = useNavigate();
    const { i18n } = useTranslation();
    const current_lang = i18n.language;
    const locale_date = current_lang === 'th' ? 'th' : 'en';
    const { count, date, mode_light, allow_col, allow_light } = props;
    const label = { inputProps: { 'aria-label': 'like shared' } };

    return (
        <div className={clsx('w-full overflow-visible flex-col flex flex-wrap gap-x-1', {
            'flex-row justify-between items-center': props.date_between,
            'flex-row justify-start items-center gap-10': props.date_row,
            'flex-col': !props.date_between,
            'md:flex-row': !allow_col
        })}>
            <span className={clsx('flex gap-3 md:gap-4', {
                "justify-center items-center": props.center,
                "justify-around items-center": props.around,
                "justify-between items-center": props.between,
                "justify-evenly items-center": props.evenly,
            })}>
                <span className="flex justify-center items-center gap-2">
                    <Checkbox
                        {...label}
                        sx={{
                            p: 0
                        }}
                        icon={
                            <FavoriteBorderIcon />
                        }
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        checked={isBoolean(count?.like_checked) ? count?.like_checked : false}
                        onChange={(e) => {
                            if (isAuthentication) {
                                count?.onLikeClick?.(e.target.checked);
                            }
                            else {
                                startTransition(() => {
                                    navigate(routeName.authentication.login_member);
                                })
                            }
                        }}
                        checkedIcon={
                            <FavoriteIcon sx={{ color: "red" }} />
                        }
                    />
                    <Box sx={(theme) => ({
                        color: allow_light ? 'white' : colors.themeMainColor
                    })} component={'span'}>
                        {count?.like || 0}
                    </Box>
                </span>
                <span>
                    <IconButton disabled={isPending} onClick={(e) => {
                        e.stopPropagation();
                        startTransition(() => {
                            count?.onViewClick?.()
                        })
                    }}>
                        {(mode_light || allow_light) ? (
                            <RemoveRedEyeIcon sx={{ color: 'white' }} />
                        ) : (
                            <IconComponents.EyeIcon />
                        )}
                    </IconButton>
                    <Box sx={(theme) => ({
                        color: allow_light ? 'white' : theme.palette.text.primary
                    })} component={'span'}>
                        {count?.view || 0}
                    </Box>
                </span>
                <span className="flex gap-6 justify-start items-center">
                    <SpeedDialCustom
                        // allow_light={allow_light}
                        onFacebookClick={props.count?.onSharedClick?.facebookClick}
                        onLineClick={props.count?.onSharedClick?.lineClick}
                        onXClick={props.count?.onSharedClick?.xClick}
                    />
                    <Box sx={(theme) => ({
                        color: allow_light ? 'white' : theme.palette.text.primary
                    })} component={'span'}>
                        {count?.shared || 0}
                    </Box>
                </span>
            </span>
            {
                date && (
                    <span className="flex justify-start items-center gap-2 md:px-2">
                        <AccessTimeIcon sx={(theme) => ({
                            color: allow_light ? 'white' : mode === 'light' ? theme.palette.text.secondary : 'white'
                        })} />
                        <Typography sx={(theme) => ({
                            color: allow_light ? 'white' : mode === 'light' ? theme.palette.text.secondary : 'white'
                        })} fontSize={14}>
                            {moment(date).locale(locale_date).add(543, 'year').format('LL')}
                        </Typography>
                    </span>
                )
            }
        </div >
    )
}